<template>
  <div class="paper-choice-set-student-add"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="cont">
      <el-form size="mini"
               label-width="100px"
               label-suffix="：">
        <el-form-item label="选择教师" required>
          <el-select v-model="form.teacherId"
                     filterable
                     size="mini"
                     placeholder="请选择教师"
                     no-data-text="没有可选择的教师">
            <template v-if="teacherList.length">
              <el-option v-for="teacher in teacherList"
                         :key="teacher.id"
                         :label="teacher.name"
                         :value="teacher.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="论文类型" required>
          <el-select v-model="form.paperTypeCode"
                     filterable
                     size="mini"
                     placeholder="请选择论文类型"
                     no-data-text="没有可选择的论文类型">
            <template v-if="paperTypeList.length">
              <el-option v-for="paperType in paperTypeList"
                          :key="paperType.id"
                          :label="paperType.name"
                          :value="paperType.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="研究方向" required>
          <el-input v-model="form.researchDirection"
                    placeholder="请输入研究方向"></el-input>
        </el-form-item>
        <el-form-item label="论文题目" required>
          <el-input v-model="form.paperTitle"
                    placeholder="请输入论文题目"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :loading="committing"
                 @click="handleApply">{{committing ? '提交中...' : '确认操作'}}</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaperChoiceSetStudentAdd',
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    extraId: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      teacherList: [],
      paperTypeList: [],
      form: {
        teacherId: '',
        paperTypeCode: '',
        researchDirection: '',
        paperTitle: ''
      }
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/choice/set/queryPaperTeacher',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.teacherList = response.data.teacherList || []
          this.paperTypeList = response.data.paperTypeList || []
        } else {
          this.errorMsg = response.data.message || '获取数据失败'
        }
      }, () => {
        this.$message.error('获取数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      const form = this.form
      if (!form.teacherId) {
        this.$message.warning('请选择教师')
        return
      }
      if (!form.paperTypeCode) {
        this.$message.warning('请选择论文题目')
        return
      }
      if (!form.researchDirection) {
        this.$message.warning('请输入研究方向')
        return
      }
      if (!form.paperTitle) {
        this.$message.warning('请输入论文题目')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/paper/choice/set/savePaperTeacherStudent',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          paperBatchId: this.paperBatchId,
          postIds: this.extraId
        }, form), {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success(response.data.message)
          this.$nextTick(() => {
            this.$emit('hidePopoverAndRefresh')
          })
        } else {
          this.$message.warning(response.data.message || '请求发送失败，请稍后重试')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          Object.keys(this.form).forEach(key => {
            this.form[key] = ''
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.paper-choice-set-student-add {
  height: 100%;
  display: flex;
  flex-direction: column;
  & > .cont {
    flex: 1;
    padding: 50px 25px 25px 15px;
    .el-form {
      width: 400px;
      margin: 0 auto;
      .el-form-item {
        &:last-child {
          margin-bottom: 0;
        }
        .el-form-item__label {
          font-size: 12px;
          padding-bottom: 0;
        }
        .el-form-item__content {
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
  & > .footer {
    height: 52px;
    background-color: #fff;
    border-top: 1px solid rgba(0,0,0,.05);
    text-align: center;
    line-height: 50px;
  }
}
</style>
